import React from "react";
import { FaUser } from "react-icons/fa";
import { IoMdCall } from "react-icons/io";
import { IoMail } from "react-icons/io5";
import { ImLocation2 } from "react-icons/im";
import { BsBoxSeamFill } from "react-icons/bs";
import locationImg from "../../Assets/About/location.svg";
import emailBoxImg from "../../Assets/About/email.svg";
import callIconImg from "../../Assets/About/call.svg";

const GetInTouch = () => {
  return (
    <div className=" px-4 sm:px-6 lg:px-10 py-8 md:py-12">
      <div className="flex flex-col lg:flex-row gap-8 xl:gap-12">
        {/* Info - Get In Touch */}
        <div className="w-full lg:w-1/2">
          <div className="mb-6">
            <p className="text-[#46B9EA] text-lg font-medium">Get In touch</p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-[#202020] font-bold mt-2 mb-4">
              We will be in touch shortly.
            </h1>
            <p className="text-[#5B5A5A] font-medium text-base sm:text-lg max-w-2xl">
              Have questions about ISO certifications or compliance
              requirements? We're here to help! Whether you're just getting
              started or need expert guidance to complete your certification
              process, our team is ready to support you every step of the way.
            </p>
          </div>

          <div className="space-y-4 ">
            {/* Contact Info Cards */}
            {[
              {
                icon: (
                  <img src={locationImg} alt="Location" className="w-6 h-6" />
                ),
                title: "Head Office",
                content:
                  "M/44, 2nd Floor, Basanti colony, Rourkela, Pin- 769012",
              },
              {
                icon: <img src={emailBoxImg} alt="Email" className="w-6 h-6" />,
                title: "Email Support",
                content: "icvcerification2011@gmail.com",
              },
              {
                icon: <img src={callIconImg} alt="Phone" className="w-6 h-6" />,
                title: "Let's talk",
                content: (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {[
                      "+91 9337233933",
                      "+91 7326979740",
                      "+91 9583146761",
                      "+91 7326979740",
                    ].map((number, index) => (
                      <a
                        key={index}
                        href={`tel:${number.replace(/\s+/g, "")}`}
                        className="hover:text-[#46B9EA] transition-colors"
                      >
                        {number}
                      </a>
                    ))}
                  </div>
                ),
              },
            ].map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-4 hover:bg-[#EDF7FD] rounded-xl transition-all"
              >
                <span className="p-3 rounded-full border-2 border-[#46B9EA]  flex-shrink-0">
                  {item.icon}
                </span>
                <div>
                  <h2 className="text-[#46B9EA] font-bold text-lg">
                    {item.title}
                  </h2>
                  <div className="text-[#5B5A5A] font-medium mt-1 text-sm sm:text-base">
                    {item.content}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Form Section */}
        <div className="w-full lg:w-1/2 bg-[#EDF7FD] rounded-2xl p-6 md:p-8 lg:p-10">
          <h2 className="font-semibold text-center text-2xl md:text-3xl text-[#202020] mb-6 md:mb-8">
            Need certification services?
            <br /> Contact us today.
          </h2>

          <form className="space-y-5">
            {[
              {
                id: "name",
                type: "text",
                placeholder: "Enter your full name",
                icon: <FaUser className="text-gray-500" />,
              },
              {
                id: "mobile",
                type: "tel",
                placeholder: "Enter mobile number",
                icon: <IoMdCall className="text-gray-500" />,
              },
              {
                id: "email",
                type: "email",
                placeholder: "Enter email address",
                icon: <IoMail className="text-gray-500" />,
              },
              {
                id: "address",
                type: "text",
                placeholder: "Enter your address",
                icon: <ImLocation2 className="text-gray-500" />,
              },
              {
                id: "subject",
                type: "text",
                placeholder: "Enter subject",
                icon: <BsBoxSeamFill className="text-gray-500" />,
              },
            ].map((field) => (
              <div
                key={field.id}
                className="rounded-xl bg-white px-5 py-3 flex items-center gap-3 border border-transparent focus-within:border-[#46B9EA] transition-all"
              >
                {field.icon}
                <input
                  type={field.type}
                  id={field.id}
                  className="flex-1 outline-none text-gray-700 placeholder-gray-400"
                  placeholder={field.placeholder}
                  required
                />
              </div>
            ))}

            <button
              type="submit"
              className="w-full bg-[#29AAE1] hover:bg-[#1E8FC6] text-white font-semibold py-3 px-6 rounded-3xl text-lg transition-colors shadow-md hover:shadow-lg"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
